import React from "react";
import { ThemeProvider } from "./src/context/ThemeContext";

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
);

export const wrapPageElement = ({ element, props }) => {
  const themeClass = props.pageContext?.themeClass || "default"; // Apply theme for templates
  return <ThemeProvider themeClass={themeClass}>{element}</ThemeProvider>;
};


export const onRouteUpdate = () => {
  if (typeof window !== "undefined") {
    window.scrollTo(0, 0);
  }
};
